import React from 'react';
import './Mission.css';
// import MissionImg from '../../img/Mission/Mission_img.png'
import { t } from "i18next";

export default class Mission extends React.Component {
    render() {
        return (
            <div className="container mission" id='mission'>
                <h3>{t("mission.title1")} <span className='blue'>{t("mission.title2")}</span>{t("mission.title3")}</h3>
                <div className='mission_wrap'>
                    {/* <div className="mission_img_block mission_item">
                        <img className="mission_img" src={MissionImg} alt="" />
                    </div> */}
                    <div className="mission_text_block mission_item">
                        <div className='mission_columns'>
                            <div className="mission_columns--item">
                                <h5 className='mission_title'>1. {t("mission.item1.title")}</h5>
                                <p className="mission_text">{t("mission.item1.desc")}</p>
                            </div>
                            <div className="mission_columns--item">
                                <h5 className='mission_title'>2. {t("mission.item2.title")}</h5>
                                <p className="mission_text">{t("mission.item2.desc")}</p>
                            </div>
                            <div className="mission_columns--item">
                                <h5 className='mission_title'>3. {t("mission.item3.title")}</h5>
                                <p className="mission_text">{t("mission.item3.desc")}</p>
                            </div>
                        </div>
                        {/* <p className="mission_text mission_text--center">Ми хочемо зібрати понад 30 невеликих доповідей (5-7 хвилин) успішних волонтерських кейсів за перші 2 тижні війни за наступними блоками:</p> */}
                    </div>
                </div>
            </div>
        )
    }
}